<template>
    <div>
        <v-container fluid>
            <br><br><br>
            <v-row>
                <v-col cols="12" class="pa-0">
                    <barraaplicacion titulo="Menu principal" />
                </v-col>
            </v-row>           

            <v-row xs="12" sm="12" justify="center" class="mt-6">

                <div v-for="op, key in opcionesMenu" :key="key" class="mx-3">        
                    
                    <!-- <v-col xs="1" sm="1" v-if="op.opcion == 1"> -->
                        <v-btn v-if="op.opcion == 1" :to="{ name: 'Taller' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-tools</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Taller</span>
                            </div>
                        </v-btn>
                    <!-- </v-col> -->

                    <!-- <v-col xs="1" sm="1" v-if="op.opcion == 2"> -->
                        <v-btn v-if="op.opcion == 2" :to="{ name: 'PanelAhorro' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-cart</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Ahorro</span>
                            </div>
                        </v-btn>
                    <!-- </v-col> -->

                    <!-- <v-col xs="1" sm="1" v-if="op.opcion == 3"> -->
                        <v-btn v-if="op.opcion == 3" :to="{ name: 'Pantallas' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-television</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Pantallas</span>
                            </div>
                        </v-btn>
                    <!-- </v-col> -->

                    <!-- <v-col xs="1" sm="1" v-if="op.opcion == 4"> -->
                        <v-btn v-if="op.opcion == 4" :to="{ name: 'ReciboMercancia' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-format-list-checks</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Recepción</span>
                            </div>
                        </v-btn>
                    <!-- </v-col> -->

                    <!-- <v-col xs="1" sm="1" v-if="op.opcion == 5"> -->
                        <v-btn v-if="op.opcion == 5" :to="{ name: 'Incidencias' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-alert-octagon</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Incidencias</span>
                            </div>
                        </v-btn>

                    <!-- </v-col> -->                       

                        <v-btn v-if="op.opcion == 8" :to="{ name: 'PanelSeguimiento' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-desktop-mac-dashboard</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Panel Seguimiento</span>
                            </div>
                        </v-btn>

                        <v-btn v-if="op.opcion == 9" :to="{ name: 'Promociones' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-gift-outline</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Promociones</span>
                            </div>
                        </v-btn>

                        <v-btn v-if="op.opcion == 10" :to="{ name: 'Promociones Reclamadas' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-ticket</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Promociones Reclamadas</span>
                            </div>
                        </v-btn>

                        <v-btn v-if="op.opcion == 11" :to="{ name: 'Imagenes Articulos' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-folder-image</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Imágenes de Artículos</span>
                            </div>
                        </v-btn>                        

                        <v-btn v-if="op.opcion == 12" :to="{ name: 'Detalle Sorteo' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-form-select</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Sorteos</span>
                            </div>
                        </v-btn>                        

                        <v-btn v-if="op.opcion == 13" :to="{ name: 'MenuSistemas' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-cog-outline</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Sistemas</span>
                            </div>
                        </v-btn>                        

                        <v-btn v-if="op.opcion == 14" :to="{ name: 'Compras Web' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-cloud-print-outline</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Compra Web</span>
                            </div>
                        </v-btn>                        

                        <v-btn v-if="op.opcion == 15" :to="{ name: 'Compras Cedis' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-factory</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Compra Cedis</span>
                            </div>
                        </v-btn>                        

                        <v-btn v-if="op.opcion == 16" :to="{ name: 'Cambio de Precios' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-currency-usd</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Cambio de Precios</span>
                            </div>
                        </v-btn>                        

                        <v-btn v-if="op.opcion == 17" :to="{ name: 'Shopify' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-cloud-sync-outline</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Shopify</span>
                            </div>
                        </v-btn>                        

                        <v-btn v-if="op.opcion == 18" :to="{ name: 'Boletos' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-ticket-confirmation-outline</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Boletos</span>
                            </div>
                        </v-btn>                        

                        <v-btn v-if="op.opcion == 19" :to="{ name: 'AltaClienteFrecuente' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-card-account-details-star-outline</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Alta Cliente Frecuente</span>
                            </div>
                        </v-btn>                        
                        
                        <v-btn v-if="op.opcion == 20" :to="{ name: 'CatalogoArticulos' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-barcode-scan</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Catálogo Artículos</span>
                            </div>
                        </v-btn>                        

                        <v-btn v-if="op.opcion == 21" :to="{ name: 'Factoraje' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-file-export-outline</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Factoraje</span>
                            </div>
                        </v-btn>                        

                        <v-btn v-if="op.opcion == 22" :to="{ name: 'AnalisisClientes' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-google-analytics</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Analisis Clientes</span>
                            </div>
                        </v-btn>                        

                        <v-btn v-if="op.opcion == 23" :to="{ name: 'Reportes' }" top height="80px" width="100%" color="resaltar primary--text" class="my-2"> 
                            <div>
                                <div class="mb-2 d-flex justify-center">
                                    <v-icon color="secondary" >mdi-marker-cancel</v-icon>
                                </div>
                                <span class="caption font-weight-medium">Cancelacion de Venta</span>
                            </div>
                        </v-btn>                        
                        
                 </div>                      

            </v-row>
           
            
        </v-container>    
    </div>
</template>

<script>

import cookie from 'vue-cookie'
import barraaplicacion from '@/components/BarraAplicacion'
import menulateral from '@/components/MenuLateral'
import MenuLateral from '../components/MenuLateral.vue'
import axios from 'axios'

export default {
    data() {
        return {
            opcionesMenu:[]
        }
    },

    components:{
        barraaplicacion,
        menulateral
    },

    created() {
        this.$store.commit('setClear')
        this.opcionesMenu = this.$store.getters.menu

        if(this.opcionesMenu.length == 0){            
            axios.get(this.$url+"/acceso/menuusuario", {headers:{authorization:`Bearer `+cookie.get('token')}})
                .then((response)=>{
                    
                    const rs = response.data

                    if(!rs.error){
                        this.$store.commit('setMenu', rs.menu)
                        this.opcionesMenu = rs.menu
                    }

                })
                .catch((error)=>{
                    console.log("Error al consultar menu "+error);
                })
        }

        let token = cookie.get('token')
        if(token ===  '' || token === null ){     
            this.$router.push({name:'Login'});
        }
    },
}
</script>

<style lang="">
    
</style>